export enum RESPONSE_PROPERTY_CONSTANTS {
  ERROR = 'error',
  SUCCESS = 'data',
}
